module.exports = __webpack_public_path__ + "img/electron-gold.6897a27c.svg";